import { NormalizedWritebackError, PimsWritebackStatus } from 'shared/types/graphql';
import { AuxiliaryPimsWritebackStatus } from '../constants';

export type IWritebackStatus = PimsWritebackStatus | AuxiliaryPimsWritebackStatus;

// If there is any successful writeback, return Success. Else, return latest status.
export const getWritebackStatus = ({
  writebackStatus,
  writebackError,
  isPaymentConfigInvalid,
  isIntegratedPayment,
}: {
  writebackStatus?: PimsWritebackStatus | null;
  writebackError?: NormalizedWritebackError | null;
  isPaymentConfigInvalid?: boolean;
  isIntegratedPayment?: boolean;
}): IWritebackStatus => {
  if (writebackStatus === PimsWritebackStatus.Success) {
    return PimsWritebackStatus.Success;
  }

  return writebackError === NormalizedWritebackError.BitwerxInvalidConfiguration && isPaymentConfigInvalid
    ? AuxiliaryPimsWritebackStatus.Invalid
    : writebackStatus
    ? writebackStatus
    : isIntegratedPayment
    ? PimsWritebackStatus.Pending
    : AuxiliaryPimsWritebackStatus.Disabled;
};
